{
  "controls": {
    "back": "Atrás",
    "close": "Cerrar",
    "last": "Listo",
    "next": "Siguiente",
    "skip": "Saltar tour"
  },
  "dashboard": {
    "greeting": {
      "title": "Bienvenido a tu panel",
      "body": "Esta es tu página de inicio — una vista rápida de oportunidades, snipes y tus principales reinos."
    },
    "kpi": {
      "title": "Oportunidades en vivo",
      "body": "Cuántos flips rentables tienes disponibles ahora mismo en todas tus herramientas."
    },
    "topOpportunities": {
      "title": "Mejores oportunidades",
      "body": "Vista previa en vivo de los mejores flips. Cambia de pestaña para ver objetos de venta rápida o mejores compras."
    },
    "snipeAlerts": {
      "title": "Snipes recientes",
      "body": "Alertas de snipe activadas durante el último ciclo de actualización. Haz clic para configurar nuevas alertas."
    },
    "realmStats": {
      "title": "Mejores reinos",
      "body": "Tus reinos de venta más fuertes ordenados por población, subastas o ratio de precios."
    },
    "quickActions": {
      "title": "Acceso rápido",
      "body": "Salta directamente a cualquier herramienta desde aquí."
    }
  },
  "flipping": {
    "dataFreshness": {
      "title": "Estado de los datos",
      "body": "Indica qué tan frescos son los datos de subasta. La página se actualiza automáticamente cuando llegan nuevos datos."
    },
    "filters": {
      "title": "Barra de filtros",
      "body": "Filtra resultados por reino, calidad, beneficio, tasa de venta y más. Guarda tus combinaciones favoritas como preajustes."
    },
    "stats": {
      "title": "Resumen de inversión",
      "body": "Totales agregados de los flips visibles: inversión necesaria, ingresos esperados y beneficio tras la comisión de la subasta."
    },
    "table": {
      "title": "Oportunidades",
      "body": "Cada fila es un flip: comprar en un reino, vender en otro. Haz clic en un objeto para copiarlo o marcarlo como favorito."
    },
    "pagination": {
      "title": "Paginación",
      "body": "Navega por las páginas de resultados y elige cuántos objetos mostrar a la vez."
    }
  },
  "housing": {
    "dataFreshness": {
      "title": "Estado de los datos",
      "body": "Indica qué tan frescos son los datos de las subastas de housing y cuándo se espera la próxima actualización."
    },
    "filters": {
      "title": "Barra de filtros",
      "body": "Filtra flips de housing por reino, beneficio, tasa de venta y precio máximo."
    },
    "stats": {
      "title": "Resumen de inversión",
      "body": "Totales de los flips de housing visibles para planificar tu presupuesto antes de comprar."
    },
    "table": {
      "title": "Oportunidades de housing",
      "body": "Cada fila es un objeto de housing barato en un reino y más valioso en otro."
    },
    "pagination": {
      "title": "Paginación",
      "body": "Navega por las páginas y ajusta cuántos resultados mostrar."
    }
  },
  "dropship": {
    "dataFreshness": {
      "title": "Estado de los datos",
      "body": "Indica qué tan frescos son los datos de dropship y cuándo llegará la próxima actualización."
    },
    "filters": {
      "title": "Barra de filtros",
      "body": "Filtra oportunidades de dropship por reino, calidad, expansión y rentabilidad."
    },
    "stats": {
      "title": "Resumen de inversión",
      "body": "Totales de los trades de dropship visibles — útil para planificar capital y capacidad."
    },
    "table": {
      "title": "Oportunidades de dropship",
      "body": "Cada fila es un objeto para comprar en un reino y revender en otro con margen."
    },
    "pagination": {
      "title": "Paginación",
      "body": "Navega por las páginas de resultados de dropship."
    }
  },
  "inventory": {
    "realms": {
      "title": "Reinos de venta",
      "body": "Elige los reinos contra los que quieres analizar tu inventario."
    },
    "csv": {
      "title": "Pega tu inventario",
      "body": "Pega aquí un CSV de tu stock separado por punto y coma — la herramienta buscará trades cruzados rentables."
    },
    "analyze": {
      "title": "Analizar",
      "body": "Ejecuta el análisis cross-realm sobre el inventario que acabas de pegar."
    },
    "results": {
      "title": "Recomendaciones de flip",
      "body": "Cada fila es un objeto de tu inventario que actualmente vale más en otro reino."
    },
    "export": {
      "title": "Exportar",
      "body": "Descarga el análisis como CSV para usarlo en una hoja de cálculo o un addon."
    }
  },
  "stats": {
    "table": {
      "title": "Estadísticas de reino",
      "body": "Compara precios de subasta, número de listados y tendencias en todos los reinos de tu región."
    }
  },
  "tsm": {
    "filters": {
      "title": "Filtros",
      "body": "Elige qué objetos incluir según categoría, expansión, calidad y beneficio."
    },
    "table": {
      "title": "Lista de objetos",
      "body": "Objetos que coinciden con tus filtros — cópialos directamente en una operación de TSM Price Source."
    },
    "pagination": {
      "title": "Paginación",
      "body": "Navega por las páginas y elige cuántos objetos mostrar a la vez."
    }
  },
  "snipe": {
    "tabs": {
      "title": "Categorías de alerta",
      "body": "Cambia entre snipes de objetos, snipes de mascotas, el token de WoW y reglas de nivel de objeto."
    },
    "add": {
      "title": "Añadir nueva alerta",
      "body": "Añade un objeto, mascota o regla a tu lista — recibirás aviso en cuanto baje del precio objetivo."
    },
    "list": {
      "title": "Alertas activas",
      "body": "Tus alertas configuradas, con precios objetivo y canales de webhook asignados."
    },
    "import": {
      "title": "Importación masiva",
      "body": "Importa una lista completa de una vez: haz clic en Importar para elegir un archivo, o simplemente pega una lista copiada en cualquier parte de esta página. Verás una vista previa antes de guardar nada."
    },
    "inlineEdit": {
      "title": "Edita precios directamente",
      "body": "Haz clic en cualquier precio de la tabla para editarlo ahí mismo: Enter guarda, Esc cancela. Las alertas eliminadas se pueden restaurar con Deshacer, y puedes ordenar la lista por nombre o precio."
    }
  },
  "tsmProfile": {
    "video": {
      "title": "Vídeo de configuración",
      "body": "Mira este vídeo corto para el tutorial completo de configuración del perfil de TSM."
    },
    "min": {
      "title": "Precio mínimo",
      "body": "Copia esta fórmula en tu operación de precio mínimo de TSM."
    },
    "max": {
      "title": "Precio máximo",
      "body": "Copia esta fórmula en tu operación de precio máximo de TSM."
    },
    "normal": {
      "title": "Precio normal",
      "body": "Copia esta fórmula en tu operación de precio normal de TSM."
    }
  },
  "settingsRealm": {
    "region": {
      "title": "Región",
      "body": "Elige US o EU — esto determina todas las listas de reinos de la app."
    },
    "buying": {
      "title": "Reinos de compra",
      "body": "Los reinos donde comprarás barato. Añade tantos como puedas visitar cómodamente."
    },
    "selling": {
      "title": "Reinos de venta",
      "body": "Los reinos donde revenderás con beneficio. Aparecen como destino en todas las herramientas."
    },
    "accounts": {
      "title": "Cuentas de WoW",
      "body": "Si juegas con varias cuentas, regístralas aquí y asígnales reinos."
    },
    "save": {
      "title": "Guardar configuración",
      "body": "Guarda y el resto de la app empezará a usar estos reinos al instante."
    }
  },
  "settingsPersonal": {
    "preview": {
      "title": "Vista previa de filtros",
      "body": "Una vista en vivo de la interfaz de filtros que verás en las herramientas de flipping."
    },
    "ranges": {
      "title": "Rangos por defecto",
      "body": "Establece los rangos de beneficio, tasa de venta y precio que quieres preaplicados en cada herramienta."
    },
    "dashboard": {
      "title": "Umbrales del dashboard",
      "body": "Controla el buyout mínimo y máximo para las oportunidades mostradas en tu dashboard."
    },
    "matching": {
      "title": "Coincidencia de objetos",
      "body": "Restringe la coincidencia de estadísticas a ciertas expansiones para precios cross-realm más precisos."
    },
    "save": {
      "title": "Guardar valores por defecto",
      "body": "Guarda esta configuración como tus ajustes personales para todas las herramientas."
    }
  },
  "rowActions": {
    "title": "Menú de acciones de fila",
    "body": "La primera columna agrupa ahora la estrella de favorito, la casilla de selección y la campana de alerta de snipe. Abre este menú para seleccionar o deseleccionar la página actual o todo a través de todas las páginas, conservar solo tus favoritos, o fijar arriba favoritos, objetivos de snipe y filas seleccionadas. Los ajustes de columnas (reordenar arrastrando y mostrar/ocultar) también están aquí."
  },
  "settingsDiscord": {
    "link": {
      "title": "Vincular Discord",
      "body": "Conecta tu cuenta de Discord para que el bot pueda enviarte alertas y notificaciones."
    },
    "verification": {
      "title": "Verificar DMs",
      "body": "Recibe un código de 6 dígitos para confirmar que el bot puede contactarte por DM."
    },
    "notifications": {
      "title": "Ajustes de notificaciones",
      "body": "Activa las notificaciones por DM para actualizaciones de región y otros eventos."
    },
    "webhooks": {
      "title": "Categorías de webhook",
      "body": "Crea categorías de webhook para dirigir las alertas de snipe a canales concretos de Discord."
    }
  },
  "classicDeals": {
    "controls": {
      "title": "Classic Deals",
      "body": "Pick your region and realms, then find same-realm undercut opportunities."
    },
    "table": {
      "title": "Deals",
      "body": "Each row is an item you can buy at the lowest price and relist just under the next-cheapest listing on the same realm."
    }
  },
  "filterMode": {
    "title": "Filtrar o recalcular",
    "body": "Elige qué ocurre al cambiar un filtro: «Filtrar» acota al instante los resultados ya cargados y «Recalcular» obtiene resultados nuevos del servidor."
  }
}
